import React from "react";

const globalRenderLimit = {
  reserved: 0,
  maxParallel: 8,
};

export const resetRenderLimits = () => {
  globalRenderLimit.reserved = 0;
  globalRenderLimit.maxParallel = 8;
};

const RenderLimiter = (
  props: React.PropsWithChildren<{
    hasCompleted: boolean;
  }>
) => {
  const [canRender, setCanRender] = React.useState(false);
  const hasAllocated = React.useRef(false);
  const hasStarted = React.useRef(false);
  React.useEffect(() => {
    const iv = setInterval(() => {
      if (!props.hasCompleted && !hasStarted.current) {
        if (globalRenderLimit.reserved < globalRenderLimit.maxParallel) {
          globalRenderLimit.reserved += 1;
          hasAllocated.current = true;
          hasStarted.current = true;
          setCanRender(true);
        }
      }
    }, 100);
    if (props.hasCompleted && hasAllocated.current) {
      if (hasAllocated.current === true) {
        globalRenderLimit.reserved -= 1;
        hasAllocated.current = false;
      }
    }
    return () => {
      window.clearInterval(iv);
    };
  }, [props.hasCompleted]);

  if (props.hasCompleted || !canRender) {
    return null;
  }

  return <div>{props.children}</div>;
};

export default RenderLimiter;
